module.exports = __webpack_public_path__ + "img/s5ForStar_193x205.aa81bdd3.png";